"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreateRoadmapController = /** @class */ (function () {
    function CreateRoadmapController($state, RoadmapsModel, FlashService, sessionTypes, instructors, reportcardTypes, documentTemplates, tasks) {
        var _this = this;
        this.$state = $state;
        this.RoadmapsModel = RoadmapsModel;
        this.FlashService = FlashService;
        this.sessionTypes = sessionTypes;
        this.instructors = instructors;
        this.reportcardTypes = reportcardTypes;
        this.documentTemplates = documentTemplates;
        this.tasks = tasks;
        this.saving = false;
        this.error = "";
        this.onSave = this.save.bind(this);
        this.onCancel = function () { return _this.$state.go("drivecoach.admin.roadmaps.index"); };
    }
    CreateRoadmapController.prototype.save = function (payload) {
        var _this = this;
        this.saving = true;
        this.error = "";
        this.RoadmapsModel.create(payload)
            .then(function (response) {
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
            _this.$state.go("drivecoach.admin.roadmaps.index");
        })
            .catch(function (error) {
            var _a;
            _this.saving = false;
            _this.error =
                ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to save the roadmap. Check that every lesson has a unique lesson number.";
        });
    };
    return CreateRoadmapController;
}());
CreateRoadmapController.$inject = [
    "$state",
    "RoadmapsModel",
    "FlashService",
    "sessionTypes",
    "instructors",
    "reportcardTypes",
    "documentTemplates",
    "tasks",
];
exports.default = CreateRoadmapController;
